module.exports = __webpack_public_path__ + "images/paknbak_smalld9699ad0bccdad6ea62eab6993aaf593.png";